import { SET_CLIENT_BALANCE } from './constant';

const initialState = {
  clientBalance: null,
};

export default function billingReducer(state = initialState, action) {
  switch (action.type) {
    case SET_CLIENT_BALANCE:
      return {
        ...state,
        clientBalance: action.payload,
      };
    default:
      return state;
  }
}
